<template>
  <div>
    <my-courses-sessions-desktop v-if="screenType === 'desktop'"></my-courses-sessions-desktop>
    <my-courses-sessions-mobile v-else></my-courses-sessions-mobile>
  </div>
</template>

<script>

import MyCoursesSessionsDesktop from "@/components/Pages/Desktop/Dashboard/Sessions/MyCoursesSessionsDesktop.vue";
import MyCoursesSessionsMobile from "@/components/Pages/Mobile/Dashboard/Sessions/MyCoursesSessionsMobile.vue";

export default {
  name: "SessionMain",
  components: {MyCoursesSessionsMobile, MyCoursesSessionsDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  },
  mounted() {
    this.getSubscriptionInfo()
  },
  methods: {
    getSubscriptionInfo() {
      window.axios.get('student/subscriptions/my').then((res) => {
        if (!res.data.data.subscriptions.length) {
          this.openSnackbar('اشتراک معتبری یافت نشد.لطفا اشتراک تهیه کنید.', '#F1416C')
          let self = this
          window.setTimeout(function () {
            self.$router.push('/dashboard/subscriptions')
          }, 3000)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>